import { render, staticRenderFns } from "./ComparisonCard.vue?vue&type=template&id=7b789634&scoped=true&"
import script from "./ComparisonCard.vue?vue&type=script&lang=js&"
export * from "./ComparisonCard.vue?vue&type=script&lang=js&"
import style0 from "./ComparisonCard.vue?vue&type=style&index=0&id=7b789634&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b789634",
  null
  
)

export default component.exports